import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import '@/assets/base.scss';
import '@/assets/common.scss';
import axios from 'axios';

Vue.use(ElementUI);
Vue.config.productionTip = false;
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
// axios.defaults.baseURL = 'https://mall.test.goldau.cn/server/resource';
document.title = '金雅福集团总部招聘官网';

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
